import { useEffect, useState } from "react";
import { Store, Check, X, Pause } from "lucide-react";
import { Shell } from "@/components/Shell";
import { client, formatApiError, label } from "@/lib/api";

const FILTERS = [["all", "Semua"], ["active", "Aktif"], ["suspended", "Dinonaktifkan"], ["pending", "Menunggu"], ["rejected", "Ditolak"]];

function SellerActions({ seller, onChange }) {
  const s = seller.status;
  return <div className="order-actions">
    {s !== "active" && <button className="primary-button compact" data-testid={`approve-seller-${seller.id}-button`} onClick={() => onChange(seller, "active")}><Check size={14}/> {s === "pending" ? "Setujui" : "Aktifkan"}</button>}
    {s === "pending" && <button className="ghost-button" data-testid={`reject-seller-${seller.id}-button`} onClick={() => onChange(seller, "rejected")}><X size={14}/> Tolak</button>}
    {s === "active" && <button className="ghost-button" data-testid={`suspend-seller-${seller.id}-button`} onClick={() => onChange(seller, "suspended")}><Pause size={14}/> Nonaktifkan</button>}
  </div>;
}

export default function Sellers() {
  const [sellers, setSellers] = useState([]);
  const [filter, setFilter] = useState("all");
  const [notice, setNotice] = useState({ text: "", error: false });
  const load = () => client.get("/admin/sellers").then(r => setSellers(r.data));
  useEffect(() => { load(); }, []);
  const change = async (seller, status) => {
    if (status !== "active" && !window.confirm(`${status === "rejected" ? "Tolak" : "Nonaktifkan"} toko ${seller.store_name}?`)) return;
    try { await client.patch(`/admin/sellers/${seller.id}/status`, { status }); setNotice({ text: `${seller.store_name}: ${label(status)}.`, error: false }); load(); }
    catch (e) { setNotice({ text: formatApiError(e, "Status penjual gagal diubah."), error: true }); }
  };
  const visible = filter === "all" ? sellers : sellers.filter(s => s.status === filter);
  return <Shell>
    <header className="page-header"><div><p className="eyebrow">PEMILIK PLATFORM</p><h1>Penjual</h1><p className="muted">Toko baru langsung aktif setelah mendaftar. Nonaktifkan toko yang melanggar aturan; data tiap toko terpisah satu sama lain.</p></div></header>
    {notice.text && <div className={`notice ${notice.error ? "error-notice" : ""}`} data-testid="seller-notice">{notice.text}</div>}
    <div className="filter-tabs" data-testid="seller-filter-tabs">
      {FILTERS.map(([key, text]) => <button key={key} data-testid={`seller-filter-${key}`} className={filter === key ? "active" : ""} onClick={() => setFilter(key)}>{text} <span>{key === "all" ? sellers.length : sellers.filter(s => s.status === key).length}</span></button>)}
    </div>
    <div className="order-list">
      {visible.map(s => <article className="order-card" key={s.id} data-testid={`seller-card-${s.id}`}>
        <div><div className="product-meta seller-meta"><span className="tag">{s.created_at.slice(0, 10)}</span><span className={`state ${s.status === "active" ? "success" : s.status === "pending" ? "waiting" : "failed"}`} data-testid={`seller-status-${s.id}`}>{label(s.status)}</span></div>
          <h3>{s.store_name}</h3><p>{s.name} · {s.email}</p></div>
        <SellerActions seller={s} onChange={change}/>
      </article>)}
      {!visible.length && <div className="empty-state" data-testid="sellers-empty-state"><Store size={30}/><b>Tidak ada penjual</b><span>Belum ada penjual dengan status ini.</span></div>}
    </div>
  </Shell>;
}
